<template>
  <div v-if="isOffline">
    <div>
      <div>
        <div>
          <div>
            <i class="pricon pricon-notice-warning pricon-2x"></i>
          </div>
          <div>
            {{ msg }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OfflineNotice',
  data() {
    return {
      msg: gavlegardarna.webapp_config.msg.offline_msg,
      isOffline: false,
    };
  },

  mounted() {
    window.addEventListener('online', this.setStatus);
    window.addEventListener('offline', this.setStatus);
    this.setStatus();
  },

  methods: {
    setStatus() {
      this.isOffline = !window.navigator.onLine;
    },
  },
};
</script>
